/* @flow */
export {default as Motion} from './Motion';
export {default as StaggeredMotion} from './StaggeredMotion';
export {default as TransitionMotion} from './TransitionMotion';
export {default as spring} from './spring';
export {default as presets} from './presets';

// deprecated, dummy warning function
export {default as reorderKeys} from './reorderKeys';



/** WEBPACK FOOTER **
 ** ./src/react-motion.js
 **/